import { DataTableStrings } from './index';
import { translateFn } from '../../../utils/translator.helper';

export const getDataTableDefaultStrings = (): DataTableStrings => ({
  copyConfirmationTooltip: translateFn('Copied'),
  emptyStateFooterButton: translateFn('Add item'),
  deleteRowTooltip: translateFn('Delete row'),
  resetPriorityButton: translateFn('Reset priority'),
  editRowTooltip: translateFn('Edit row'),
  cancelEditTooltip: translateFn('Cancel changes'),
  validateEditTooltip: translateFn('Validate changes'),
  disabledEditTooltip: translateFn('Validation failed due to errors'),
  requiredFieldMessage: translateFn('This field is required'),
  extraValidationToastMessage: translateFn('Duplicate entry. Changes cannot be saved.'),
  textInputPlaceholder: translateFn('Type here'),
  dropdownApplyButtonString: translateFn('Apply'),
  dropdownAllItemsLabel: translateFn('All'),
});
